export default "__VITE_ASSET__B63NniLf__"